import { supabase } from '@/lib/supabase';

interface ClinicSenderNameRow {
  sender: string;
  sender_name: string | null;
  sender_user_id: string | null;
}

export async function fillMissingClinicSenderNames<T extends ClinicSenderNameRow>(
  messages: T[],
): Promise<T[]> {
  const userIds = [
    ...new Set(
      messages
        .filter(
          (message) =>
            message.sender === 'clinic' &&
            !message.sender_name?.trim() &&
            message.sender_user_id,
        )
        .map((message) => message.sender_user_id as string),
    ),
  ];

  if (userIds.length === 0) return messages;

  const { data, error } = await supabase.from('users').select('id, name').in('id', userIds);
  if (error || !data?.length) return messages;

  const names = new Map(data.map((user) => [user.id, user.name]));
  return messages.map((message) => {
    if (
      message.sender === 'clinic' &&
      !message.sender_name?.trim() &&
      message.sender_user_id
    ) {
      const name = names.get(message.sender_user_id);
      if (name) return { ...message, sender_name: name };
    }
    return message;
  });
}
